import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationLinkedInvestigationEntity } from '../../../domain/entities/investigation-linked-investigation.entity';

export interface GetLinkedInvestigationsQuery { investigationId: string; }
export interface GetLinkedInvestigationsResult { linkedInvestigations: InvestigationLinkedInvestigationEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetLinkedInvestigationsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetLinkedInvestigationsQuery): Observable<GetLinkedInvestigationsResult> {
    this._state.setLoadingLinkedInvestigations(true);
    this._state.setErrorLinkedInvestigations(null);
    return this._repository.getLinkedInvestigations(query.investigationId).pipe(
      tap((items) => {
        this._state.setLinkedInvestigations(items);
        this._state.setLoadingLinkedInvestigations(false);
      }),
      map((items) => ({ linkedInvestigations: items })),
      catchError((error) => {
        this._state.setErrorLinkedInvestigations(error.message || 'Failed to load linked investigations');
        this._state.setLoadingLinkedInvestigations(false);
        return throwError(() => error);
      }),
    );
  }
}
